export const C_TOKEN = "Fmg8ho_gvc]vruvkiN";

export const MENUS = [
  {
    name: "History Log",
    url: "/history-log",
    icon: "fa-history",
    roles: [0, 1],
    urls: ["/history-log"]
  },
  {
    name: "LPR Management",
    url: "/reservation",
    icon: "fa-car",
    roles: [0, 1],
    urls: ["/reservation", "/add-reservation", "/edit-reservation"]
  },
  {
    name: "User Management",
    url: "/user-management",
    icon: "fa-users",
    roles: [1],
    urls: ["/user-management", "/add-user", "/edit-user"]
  },
  {
    name: " Advertising Management",
    url: "/media",
    icon: "fa-audio-description",
    roles: [0, 1],
    urls: ["/media", "/add-media", "/edit-media"]
  }
];
export const DATETHAI_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT = "DD/MM/YYYY";
export const DATETIME_FORMAT = "DD MMMM YYYY HH:mm:ss";
export const DATETIME_SEARCH_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DATE_SEARCH_FORMAT = "YYYY-MM-DD";
export const DATETIME_PAYMENT_FORMAT = "DD/MM/YYYY - HH:mm";
export const API_URL = "http://localhost:5001"; //'http://alpr.central.tu.ac.th:5001'

export const TYPE_CODES = {
  TA: "MTI06119",
  PA: "MTI06113",
  HT: "MTI06200",
  FA: "MTI06128",
  TAPS: "MTI06149",
  TS:"MTI06200_AOT",
};


export const BANK_DEFAULT_SELECT = 'โปรดเลือก';